import { render, staticRenderFns } from "./ExtraServiceExpandStorageThreshold.vue?vue&type=template&id=0222e502&"
import script from "@/scripts/modal/extraService/extraServiceExpandStorageThreshold.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/extraService/extraServiceExpandStorageThreshold.js?vue&type=script&lang=js&"
import style0 from "./ExtraServiceExpandStorageThreshold.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports